module.exports = __webpack_public_path__ + "static/media/baggageTrolley.5bc37401.svg";